<div class="row" *ngIf="record.galleryCollection === 'plants'; else nonPlant">
  <div class="col-xs-12">
    {{ record.latin }}
  </div>
  <div class="col-xs-12">
    {{ record.description }}
  </div>
  <div class="row row-meta" *ngIf="record.isNative">
    <div class="col-xs-12">
      <button nbButton shape="round" status="info" size="tiny">Native Plant</button>
    </div>
  </div>
  <div class="row row-meta">
    <div class="col-xs-6">
      <strong>
        <nb-icon icon="arrow-upward-outline"> </nb-icon>
        Height:
      </strong>
      {{ record.height }} {{ record.heightUnit }}
    </div>
    <div class="col-xs-6">
      <strong>
        <nb-icon icon="swap-outline"> </nb-icon>
        Spread:
      </strong>
      {{ record.spread }} {{ record.spreadUnit }}
    </div>
    <div class="col-xs-12">
      <strong>
        <nb-icon icon="sun"> </nb-icon>
        Sun Exposure:
      </strong>
      <br />
      <button
        nbButton
        shape="round"
        status="primary"
        size="tiny"
        *ngFor="let sun of record.sunExposure"
      >
        {{ sun }}
      </button>
    </div>
  </div>
</div>
<ng-template class="row" #nonPlant>
  <div class="col-xs-12" *ngIf="showDescription()">
    {{ record.description }}
  </div>
</ng-template>
